import { useBitrix } from '@context/useBitrixUser/useBitrix';
import { companyProfileService } from '@services/requests/companyProfileService';
import { DocumentsData } from '@services/requests/companyProfileService/types/documentsData';
import React, { useEffect, useState } from 'react';

import { DocumentsModule } from '../../CompanyProfileModules/DocumentsModule';
import { DocumentsTabSkeleton } from './DocumentsTabSkeleton';
import { getDocumentIcon } from './getDocumentIcon';
import { DocumentsTabStyledContainer } from './StyledComponents';

interface DocumentsTabProps {
  isAllowEdit: boolean;
}

function DocumentsTab({ isAllowEdit }: DocumentsTabProps) {
  const [documentsData, setDocumentsData] = useState<DocumentsData | null>(null);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<string[]>([]);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser, isUserLoading }] = useBitrixUser().useState();

  useEffect(() => {
    if (!bitrixUser && !isUserLoading) {
      setIsDataLoading(false);
    }
    if (!bitrixUser || isUserLoading) {
      return;
    }
    const fetchData = async () => {
      const result = await companyProfileService().LoadDocumentsData(bitrixUser.id);
      if ('errors' in result) {
        setIsDataLoading(false);
        setErrors(result.errors);
        return;
      }

      setIsDataLoading(false);
      setDocumentsData(result);
    };
    fetchData();
  }, [bitrixUser, isUserLoading]);

  if (errors.length > 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {errors.map((error, index) => (
          <div key={'error-' + index}>
            <span className="company-status error">{error}</span>
          </div>
        ))}
      </div>
    );
  }

  if (isDataLoading) {
    return <DocumentsTabSkeleton />;
  }

  if (!documentsData) {
    return null;
  }

  return (
    <DocumentsTabStyledContainer>
      {Object.values(documentsData.sections).map((section) => (
        <DocumentsModule
          key={section.code}
          Icon={getDocumentIcon(section.code)}
          title={section.caption}
          documents={section.fields}
          editText={documentsData.messages.btn_edit}
          uploadText={documentsData.messages.btn_upload}
          isAllowEdit={isAllowEdit}
          isArrayDocuments={false}
          serviceType="company-profile"
        />
      ))}
    </DocumentsTabStyledContainer>
  );
}

export { DocumentsTab };
